import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import Chart from "react-apexcharts";
import { stateChart } from "../../../utils/stateChart";
import { Link } from "react-router-dom";

const initialState = stateChart([
  "SON MULTIDISCIPLINARIOS",
  "NO SON MULTIDISCIPLINARIOS",
]);

const ReportByLine = ({ projects, lines }) => {
  const quantityProgramsByProjects = (valor) => {
    let pp,
      cont = 0,
      lp,
      res;
    res = projects
      .filter((project) => project.lines.length >= 1)
      .map((filteredProgram) => filteredProgram.lines);
    pp = res.flat();
    lp = pp.map((filteredProgram) => filteredProgram.id);

    for (let i = 0; i < lp.length; i++) {
      if (lp[i] === valor) {
        cont = cont + 1;
      }
    }
    return cont;
  };

  const listPrograms = lines.map((filteredPerson) => (
    <li>
      {" "}
      <h5>
        {filteredPerson.name.toUpperCase()} :{" "}
        {quantityProgramsByProjects(filteredPerson.id)} <br />{" "}
      </h5>
    </li>
  ));

  return (
    <Grid item xs={8} sm={8} md={12}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <h3> Lista de Líneas</h3>
        <ol>
          {listPrograms} <br />
        </ol>
      </Paper>
    </Grid>
  );
};

export default ReportByLine;
